/* Imperia Events Landing - calculator, gallery slider, lightbox (data-ic-* hooks) */
(function () {
  'use strict';

  function initCalculator(root) {
    if (!root || root.getAttribute('data-ic-calc') === 'true') return;
    root.setAttribute('data-ic-calc', 'true');

    var q = function (n) { return root.querySelector('[data-ic-' + n + ']'); };
    var G = q('guests'), S = q('style'), B = q('buffer'), T = q('tin'), U = q('update');
    var out = q('total'), sum = q('summary'), base = q('base'), buf = q('buffered'), kg = q('kg'), oz = q('oz');
    var resultBox = root.querySelector('.result') || (out && out.closest('.result'));
    var emailLink = root.querySelector('a[href^="mailto:concierge"]') ||
      (root.querySelector('#caviar-calculator') && root.querySelector('#caviar-calculator').querySelector('a.btn[href^="mailto:"]'));
    // Prefer the email CTA inside calculator section
    var calcSec = root.querySelector('#caviar-calculator');
    if (calcSec) {
      var mailBtns = calcSec.querySelectorAll('a.btn[href^="mailto:"]');
      if (mailBtns.length) emailLink = mailBtns[mailBtns.length - 1];
    }
    if (!G || !S || !B || !T) return;

    var fmt = function (n) { return Math.round(n).toLocaleString() + 'g'; };
    var set = function (el, v) { if (el) el.textContent = v; };

    var last = { g: 0, pp: 0, b: 0, t: 0, total: 0, tins: 0, bs: 0, need: 0 };

    var calc = function (opts) {
      opts = opts || {};
      var g = Math.max(1, parseFloat(G.value) || 1);
      var pp = parseFloat(S.value) || 15;
      var b = parseFloat(B.value) || 1.15;
      var t = parseFloat(T.value) || 125;
      var bs = g * pp;
      var need = bs * b;
      var tins = Math.ceil(need / t) || 1;
      var total = tins * t;

      last = { g: g, pp: pp, b: b, t: t, total: total, tins: tins, bs: bs, need: need };

      set(base, fmt(bs));
      set(buf, fmt(need));
      set(out, fmt(total));
      set(kg, (total / 1000).toFixed(total >= 1000 ? 2 : 3) + 'kg');
      set(oz, (total / 28.3495).toFixed(1) + 'oz');
      set(sum, 'About ' + tins + ' x ' + t + 'g tins for ' + g + ' guests.');

      // Keep mailto body in sync with current estimate
      if (emailLink && emailLink.href) {
        try {
          var styleLabel = (S.options[S.selectedIndex] && S.options[S.selectedIndex].text) || (pp + 'g/guest');
          var bufferLabel = (B.options[B.selectedIndex] && B.options[B.selectedIndex].text) || (Math.round((b - 1) * 100) + '% buffer');
          var body =
            'Hi Imperia Caviar,%0A%0A' +
            'I used the caviar calculator and would like help finalizing my event estimate.%0A%0A' +
            'Guest count: ' + g + '%0A' +
            'Service style: ' + encodeURIComponent(styleLabel) + '%0A' +
            'Service buffer: ' + encodeURIComponent(bufferLabel) + '%0A' +
            'Preferred tin size: ' + t + 'g%0A' +
            'Estimated order: ' + Math.round(total) + 'g (~' + tins + ' x ' + t + 'g tins)%0A' +
            'Base caviar: ' + Math.round(bs) + 'g%0A' +
            'With buffer: ' + Math.round(need) + 'g%0A%0A' +
            'Event date:%0AEvent location:%0A%0AThank you.';
          emailLink.href =
            'mailto:concierge@imperiacaviar.com' +
            '?subject=' + encodeURIComponent('Caviar Event Estimate Request') +
            '&body=' + body;
        } catch (err) {}
      }

      if (opts.flash && resultBox) {
        resultBox.classList.remove('ic-calc-flash');
        void resultBox.offsetWidth;
        resultBox.classList.add('ic-calc-flash');
      }
      if (opts.scroll && resultBox) {
        try {
          resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (err2) {}
      }
      return false;
    };

    var onUpdateClick = function (e) {
      if (e) {
        try { e.preventDefault(); } catch (err) {}
        try { e.stopPropagation(); } catch (err2) {}
      }
      calc({ flash: true, scroll: true });
      return false;
    };

    root.__icCalc = onUpdateClick;
    window.__icCalcFrom = function (el) {
      var r = el && el.closest ? el.closest('[data-ic-root]') : root;
      if (r && r.__icCalc) return r.__icCalc();
      return false;
    };

    if (U) {
      U.setAttribute('type', 'button');
      U.addEventListener('click', onUpdateClick, true);
      U.addEventListener('click', onUpdateClick, false);
      U.setAttribute('onclick', 'return (window.__icCalcFrom && window.__icCalcFrom(this)), false;');
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-ic-update]')) onUpdateClick(e);
    }, true);

    // Enter in guests field also runs update
    G.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        onUpdateClick(e);
      }
    });

    // Initial numbers on load (no flash)
    calc({ flash: false, scroll: false });
  }

  function initGallery(root, openLightbox) {
    if (!root || root.getAttribute('data-ic-gallery') === 'true') return;
    root.setAttribute('data-ic-gallery', 'true');

    var track = root.querySelector('[data-ic-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ic-slide]'));
    var prev = root.querySelector('[data-ic-prev]');
    var next = root.querySelector('[data-ic-next]');
    var i = 0;

    var visibleCount = function () {
      if (!track || !slides.length) return 1;
      var trackW = track.parentElement ? track.parentElement.clientWidth : 0;
      var slideW = slides[0].offsetWidth || slides[0].getBoundingClientRect().width || 0;
      if (!trackW || !slideW) return 1;
      return Math.max(1, Math.round(trackW / slideW));
    };

    var move = function () {
      if (!track || !slides.length) return;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      var slideW = slides[0].offsetWidth || slides[0].getBoundingClientRect().width || 0;
      if (!slideW) return;
      var step = slideW + gap;
      var max = Math.max(0, slides.length - visibleCount());
      i = Math.max(0, Math.min(i, max));
      track.style.transform = 'translateX(' + (-i * step) + 'px)';
    };

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); i--; move(); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); i++; move(); });
    window.addEventListener('resize', move);
    move();

    if (openLightbox) {
      slides.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          openLightbox(a.getAttribute('href'), a.getAttribute('data-title') || '');
        });
      });
    }
  }

  function initLightbox(root) {
    var box = root.querySelector('[data-ic-lightbox]');
    if (!box) return null;
    var img = box.querySelector('[data-ic-lightbox-img]');
    var cap = box.querySelector('[data-ic-caption]');
    var x = box.querySelector('[data-ic-close]');

    var close = function () {
      box.classList.remove('open');
      box.setAttribute('aria-hidden', 'true');
      if (img) img.removeAttribute('src');
      document.body.style.overflow = '';
    };
    var open = function (src, title) {
      if (img) {
        img.src = src;
        img.alt = title || 'Imperia Caviar event photo';
      }
      if (cap) cap.textContent = title || '';
      box.classList.add('open');
      box.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    if (x) x.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('open')) close();
    });
    return open;
  }

  function init(root) {
    if (!root) return;
    initCalculator(root);
    var open = initLightbox(root);
    initGallery(root, open);
    root.setAttribute('data-ic-ready', 'true');
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ic-root]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  window.addEventListener('load', function () { initAll(); });
  setTimeout(function () { initAll(); }, 800);

  // After contact form redirect (?contact_posted=true), focus success message
  function focusFormSuccess() {
    var params = new URLSearchParams(window.location.search || '');
    var ok = params.get('contact_posted') === 'true' || params.get('contact_posted') === '1';
    var el = document.getElementById('ic-form-success');
    if (!ok && !el) return;
    if (!el) {
      var box = document.querySelector('#event-inquiry .formbox');
      if (box) {
        el = document.createElement('p');
        el.id = 'ic-form-success';
        el.className = 'ic-form-success note full';
        el.setAttribute('role', 'status');
        el.textContent = 'Thank you. Our concierge will be in touch shortly.';
        box.insertBefore(el, box.firstChild);
      }
    }
    if (el) {
      try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      try { el.focus(); } catch (e2) {}
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusFormSuccess);
  } else {
    focusFormSuccess();
  }
  window.addEventListener('load', focusFormSuccess);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
